import React, { useEffect } from "react";
import { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  editCategory,
  viewCategory,
} from "../../Redux/Actions/categoryActions";
import AddImage from "../../Global Functions/addImage";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import TextInput from "../../Global Functions/textInput";

const EditSubCategories = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const [subCategory, setSubCategory] = useState({
    id: id,
    name: "",
    position: "",
    icon: "",
    image: "",
    three_d_icon: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(viewCategory(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { category } = useSelector((state) => state.categories || {});

  useEffect(() => {
    if (category?.data) {
      setSubCategory((prevData) => ({
        ...prevData,
        ...category?.data,
        id: id,
      }));
    }
  }, [category, id]);

  const handleImageUpload = async (event, type) => {
    const uploadedFile = event.target.files[0];

    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);

    if (responseUrl) {
      setSubCategory((prevData) => ({ ...prevData, [type]: responseUrl }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const filteredData = Object.fromEntries(
        Object.entries(subCategory).filter(
          ([key, value]) =>
            value !== "" && value !== null && value !== undefined
        )
      );
      const response = await dispatch(editCategory(filteredData));
      if (response.statusCode === 200) {
        navigate(-1);
      }
    } catch (error) {
      console.log(error?.data?.response?.message);
    }
  };

  return (
    <MainLayout>
      <div
        style={{
          marginTop: "10px",
          paddingTop: "10px",
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 20px",
            alignItems: "center",
          }}
        >
          <h1>Edit Sub Category</h1>
          <button onClick={() => navigate(-1)} className="button-class">
            View Sub-Category List
          </button>
        </div>
        <form style={{ padding: "0px 20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <span className="span-class">Upload Sub-Category's Image</span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="image"
                id="image"
                onChange={(event) => handleImageUpload(event, "image")}
              />
              <label className="label-class-image" for="image">
                Click To Upload Image
              </label>
              <ImageShowerModalGlobal
                state={subCategory}
                keyField="image"
                setState={setSubCategory}
                file={subCategory.image}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Upload Sub-Category's Icon</span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="icon"
                id="icon"
                onChange={(event) => handleImageUpload(event, "icon")}
              />
              <label className="label-class-image" for="icon">
                Click To Upload Icon
              </label>
              <ImageShowerModalGlobal
                state={subCategory}
                keyField="icon"
                setState={setSubCategory}
                file={subCategory.icon}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                value={subCategory.name}
                label="Sub Category Name"
                placeholder="Enter Name"
                onChange={(event) => {
                  setSubCategory({ ...subCategory, name: event.target.value });
                }}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Upload 3D Icon</span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="three_d_icon"
                id="three_d_icon"
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
              />
              <label className="label-class-image" for="three_d_icon">
                Click To Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCategory.three_d_icon}
                setState={setSubCategory}
                state={subCategory}
                keyField="three_d_icon"
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div
            className="flex-end gap-10"
            style={{
              margin: "20px auto ",
            }}
          >
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="button-class-white"
            >
              Cancel
            </button>
            <button className="button-class" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditSubCategories;
